<template>
  <div class="d-flex flex-column gap-12 mb-6">
    <divcard>
      <div class="card-part pt-0">
        <div class="txt-head black--text mb-2">
          <span class="theme-color-one">ส่วนที่ 1 :</span> ข้อมูลทั่วไป
        </div>

        <!-- Form 1 -->
        <div>
          <div class="txt-head black--text mb-3">1. ชื่อโครงการ</div>
          <!-- Form 1 #line1 -->
          <div class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                แผนงาน
                <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
              </div>
              <TextField
                readonly
                theme="3"
                :value="masterData.plan_master?.plan_name_th"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line2 -->
          <div
            v-if="
              masterData.plan_master?.plan_code &&
              (masterData.plan_master.plan_code === 'IRTC' ||
                masterData.plan_master.plan_code === 'CR' ||
                masterData.plan_master.plan_code === 'SP')
            "
          >
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ชื่อโครงการ (ภาษาไทย)
                  <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
                </div>
                <TextField
                  theme="3"
                  :value="form.project_name_th"
                  @onChange="setFormField('project_name_th', $event)"
                ></TextField>
              </div>
            </div>

            <!-- Form 1 #line3 -->
            <div v-if="masterData.plan_master.plan_code !== 'SP'" class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ชื่อโครงการ (ภาษาอังกฤษ)
                  <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
                </div>
                <TextField
                  theme="3"
                  :value="form.project_name_en"
                  @onChange="setFormField('project_name_en', $event)"
                ></TextField>
              </div>
            </div>
          </div>

<!--          <div-->
<!--            v-if="-->
<!--              masterData.plan_master?.plan_code &&-->
<!--              masterData.plan_master.plan_code === 'SP'-->
<!--            "-->
<!--          >-->
<!--            <div class="flex-center gap-16">-->
<!--              <div class="flex">-->
<!--                <div class="mb-1 black&#45;&#45;text">-->
<!--                  ชื่อห้องปฏิบัติการ-->
<!--                  <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>-->
<!--                </div>-->
<!--                <TextField-->
<!--                  theme="3"-->
<!--                  :value="form.lab_name"-->
<!--                  @onChange="setFormField('lab_name', $event)"-->
<!--                ></TextField>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

          <div
            v-if="
              masterData.plan_master?.plan_code &&
              masterData.plan_master.plan_code === 'STI'
            "
          >
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">กิจกรรม</div>
                <AutoBox
                  theme="3"
                  :items="masterData.activity_sti"
                  itemText="name"
                  itemValue="id"
                  :value="
                    form.activity
                      ? masterData.activity_sti[form.activity - 1]?.id
                      : ''
                  "
                  @onChange="setFormField('activity', $event)"
                ></AutoBox>
              </div>
            </div>
            <div class="flex-center gap-16">
              <div class="flex">
                <div class="mb-1 black--text">
                  ชื่อโครงการ (ภาษาไทย)
                  <span class="theme-color-seven txt-normal">(โปรดระบุ)</span>
                </div>
                <TextField
                  theme="3"
                  :value="form.project_name_th"
                  @onChange="setFormField('project_name_th', $event)"
                ></TextField>
              </div>
            </div>
          </div>


          <!-- Form 1 #line4 -->
          <div
            v-if="
              masterData.plan_master?.plan_code &&
              masterData.plan_master.plan_code !== 'STI'
            "
            class="flex-center gap-16"
          >
            <div class="flex">
              <div class="mb-1 black--text">อ้างอิง (Requirement Form)</div>
              <AutoBox
                theme="3"
                :items="masterData.requirement_forms"
                itemText="doc_no"
                itemValue="id"
                :value="form.requirement_form_id"
                @onChange="setFormField('requirement_form_id', $event)"
              ></AutoBox>
            </div>
          </div>

          <!-- Form 1 #line5 -->
          <div v-if="masterData.plan_master?.plan_code === 'SP' || (masterData.plan_master?.plan_code === 'CR' && (this.isFinal)) " class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                หน่วยงานที่รับผิดชอบ อุทยานวิทยาศาตร์ภาค
              </div>
              <TextField
                  readonly
                  theme="3"
                  :value="form.science_park"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line7 -->
          <div v-if="masterData.plan_master?.plan_code === 'CR' && (this.isFinal) " class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                งบประมาณทั้งโครงการ
              </div>
              <TextField
                  readonly
                  theme="3"
                  :value="masterData.form_c?.budget_amount"
              ></TextField>
            </div>
          </div>

          <!-- Form 1 #line8 -->
          <div v-if="masterData.plan_master?.plan_code === 'CR' && (this.isFinal) " class="flex-center gap-16">
            <div class="flex">
              <div class="mb-1 black--text">
                ระยะเวลาการดำเนินงาน (เดือน)
              </div>
              <TextField 
                  theme="3"
                  :value="form.operation_period"
                  @onChange="setFormField('operation_period', $event)"
              ></TextField>
            </div>
          </div>

        </div>
      </div>
    </divcard>

    <!-- 2. ตารางแสดงรายชื่อผู้ประกอบการที่เข้ารับการบริการห้องปฏิบัติการ -->
    <divcard v-if="masterData?.plan_master?.plan_code === 'SP'">
      <div class="mb-3 black--text txt-head">
        2. ตารางแสดงรายชื่อผู้ประกอบการที่เข้ารับการบริการห้องปฏิบัติการ
      </div>

      <!-- header table -->
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th
                width="10%"
                class="font-14 font-w-400"
                style="border-bottom: 0px"
              >
                ประเภทผู้ประกอบการ
              </th>
              <th
                width="10%"
                class="font-14 font-w-400 text-center"
                style="border-bottom: 0px"
              >
                จัดการ
              </th>
              <th
                width="5%"
                class="font-14 font-w-400 text-center"
                style="border-bottom: 0px"
              >
                ลำดับ
              </th>
              <th
                width="23%"
                class="font-14 font-w-400"
                style="border-bottom: 0px"
              >
                ชื่อผู้ประกอบการและชื่อนิติบุคคล
              </th>
              <th
                width="15%"
                class="font-14 font-w-400"
                style="border-bottom: 0px"
              >
                รายละเอียดห้องปฎิบัติการ
              </th>
              <th
                width="10%"
                class="font-14 font-w-400"
                style="border-bottom: 0px"
              >
                เครื่องมือที่ใช้
              </th>
              <th
                width="10%"
                class="font-14 font-w-400"
                style="border-bottom: 0px"
              >
                ผลิตภัณฑ์ที่มาใช้บริการ
              </th>
              <th
                width="10%"
                class="font-14 font-w-400"
                style="border-bottom: 0px"
              >
                รหัสห้องปฎิบัติการNSTIS(Lab ID)
              </th>
              <th
                width="7%"
                class="font-14 font-w-400"
                style="border-bottom: 0px"
              >
                จำนวนครั้ง
              </th>
            </tr>
          </thead>
        </template>
      </v-simple-table>

      <!-- body table -->
      <div>
        <v-card
          v-for="(company_contact, company_contacts_index) in company_contacts"
          :key="company_contacts_index"
          class="mb-4"
          style="border-radius: 20px; box-shadow: unset; overflow: hidden"
        >
          <v-simple-table class="custom_simple_table">
            <template v-slot:default>
              <tbody>
                <tr v-if="company_contact.items.length == 0">
                  <td width="10%" style="border-bottom: 0px">
                    <v-layout align-center>
                      <v-flex shrink class="pt-2 mr-2">
                        <v-btn
                          color="#F15A29"
                          class="mb-3"
                          max-width="20px"
                          max-height="20px"
                          fab
                          dark
                          depressed
                          rounded
                          @click="addCompanyContact(company_contact.type)"
                        >
                          +
                        </v-btn>
                      </v-flex>
                      <v-flex>{{ company_contact.type }}</v-flex>
                    </v-layout>
                  </td>
                  <td
                    colspan="8"
                    class="text-center"
                    style="border-bottom: 0px; color: #b1b1b1"
                  >
                    <div class="text-center py-4">ไม่มีข้อมูล</div>
                  </td>
                </tr>
                <tr
                  v-else
                  v-for="(item, index) in company_contact.items"
                  :key="index"
                >
                  <td width="10%" style="border-bottom: 0px">
                    <v-layout align-center v-if="index == 0">
                      <v-flex shrink class="pt-2 mr-2">
                        <v-btn
                          color="#F15A29"
                          class="mb-3"
                          max-width="20px"
                          max-height="20px"
                          fab
                          dark
                          depressed
                          rounded
                          @click="addCompanyContact(company_contact.type)"
                        >
                          +
                        </v-btn>
                      </v-flex>
                      <v-flex>{{ company_contact.type }}</v-flex>
                    </v-layout>
                  </td>
                  <td
                    width="10%"
                    class="text-center"
                    style="border-bottom: 0px"
                  >
                    <v-btn
                      icon
                      @click="editCompanyContact(company_contacts_index, index)"
                    >
                      <v-icon color="#F15A29"> mdi-pencil </v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      :disabled="companyContactIndex == index"
                      @click="
                        deleteCompanyContact(company_contacts_index, index)
                      "
                    >
                      <v-icon color="#B1B1B1"> mdi-delete </v-icon>
                    </v-btn>
                  </td>
                  <td width="5%" class="text-center" style="border-bottom: 0px">
                    {{ index + 1 }}
                  </td>
                  <td width="23%" style="border-bottom: 0px">
                    {{ item.op_name }}/{{ item.juristic_name }}
                  </td>
                  <td width="15%" style="border-bottom: 0px">
                    {{ item.lab_detail }}
                  </td>
                  <td width="10%" style="border-bottom: 0px">
                    {{ item.instrument }}
                  </td>
                  <td width="10%" style="border-bottom: 0px">
                    {{ item.product_used }}
                  </td>
                  <td width="10%" style="border-bottom: 0px">
                    {{ item.lab_id }}
                  </td>
                  <td width="7%" class="text-center" style="border-bottom: 0px">
                    {{ item.count }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
      </div>

      <!-- Form เพิ่มปีงบประมาณ -->
      <transition name="fade">
        <v-form
          class="mt-6 company_contacts_form"
          ref="company_contacts_form"
          v-model="valid_company_contacts"
          lazy-validation
          v-if="is_company_contacts_form"
        >
          <v-divider />

          <div class="my-3">
            <v-icon> mdi-pencil </v-icon>
            เพิ่ม
          </div>

          <v-row>
            <v-col cols="12">
              <label>ประเภทผู้ประกอบการ</label>
              <v-text-field
                v-model="company_contacts_form.op_type"
                outlined
                color="#D3D3D3"
                rounded
                readonly
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="5">
              <label>ชื่อผู้ประกอบการ</label>
              <v-text-field
                v-model="company_contacts_form.op_name"
                outlined
                color="#D3D3D3"
                rounded
                :rules="[(v) => !!v || 'กรุณาระบุชื่อผู้ประกอบการ']"
              ></v-text-field>
            </v-col>
            <v-col cols="5">
              <label>ชื่อนิติบุคคล</label>
              <v-text-field
                v-model="company_contacts_form.juristic_name"
                outlined
                color="#D3D3D3"
                rounded
                :rules="[(v) => !!v || 'กรุณาระบุชื่อนิติบุคคล']"
              ></v-text-field>
            </v-col>
            <v-col cols="2">
              <label>จำนวนครั้ง</label>
              <v-text-field
                v-model="company_contacts_form.count"
                outlined
                type="number"
                color="#D3D3D3"
                rounded
                :rules="[(v) => !!v || 'กรุณาระบุปีงบประมาณ']"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <label>รายละเอียดห้องปฎิบัติการ</label>
              <v-text-field
                v-model="company_contacts_form.lab_detail"
                outlined
                color="#D3D3D3"
                rounded
                :rules="[(v) => !!v || 'กรุณาระบุรายละเอียดห้องปฎิบัติการ']"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <label>เครื่องมือที่ใช้</label>
              <v-text-field
                v-model="company_contacts_form.instrument"
                outlined
                color="#D3D3D3"
                rounded
                :rules="[(v) => !!v || 'กรุณาระบุเครื่องมือที่ใช้']"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <label>ผลิตภัณฑ์ที่มาใช้บริการ</label>
              <v-text-field
                v-model="company_contacts_form.product_used"
                outlined
                color="#D3D3D3"
                rounded
                :rules="[(v) => !!v || 'กรุณาระบุผลิตภัณฑ์ที่มาใช้บริการ']"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <label>รหัสห้องปฎิบัติการไปยังระบบ NSTIS (Lab ID)</label>
              <v-text-field
                v-model="company_contacts_form.lab_id"
                outlined
                color="#D3D3D3"
                rounded
                :rules="[
                  (v) =>
                    !!v ||
                    'กรุณาระบุรหัสห้องปฎิบัติการไปยังระบบ NSTIS (Lab ID)',
                ]"
              ></v-text-field>
            </v-col>
          </v-row>

          <div class="d-flex justify-end gap-16">
            <v-btn
              color="#F5F5F5"
              class="mb-3"
              min-width="80px"
              depressed
              rounded
              @click="clearCompanyContactForm"
            >
              ยกเลิก
            </v-btn>
            <v-btn
              color="#F15A29"
              class="mb-3"
              min-width="80px"
              depressed
              dark
              rounded
              @click="handleSubmitCompanyContactForm"
            >
              ยืนยัน
            </v-btn>
          </div>
        </v-form>
      </transition>

    </divcard>
  </div>
</template>

<script>
import TextField from "../../../components/input/TextField";
import SwitchInset from "../../../components/input/SwitchInset";
import AutoBox from "../../../components/input/AutoBox";
import { eventBus } from "../../../plugins/global-funcs";
import { mapState } from "vuex";

export default {
  name: "CFormGeneral",
  components: {
    TextField,
    SwitchInset,
    AutoBox,
  },
  props: {
    masterData: {
      default: () => ({}),
    },
    isSameId: {
      default: false,
    },
  },
  data() {
    return {
      form: {},

      // company_contacts
      is_company_contacts_form: false,
      company_contacts: [
        {
          type: "ในมหาวิทยาลัย",
          items: [],
        },
        {
          type: "นอกมหาวิทยาลัย",
          items: [],
        },
        {
          type: "ในโครงการอุทยานวิทยาศาสตร์",
          items: [],
        },
      ],
      valid_company_contacts: true,
      company_contacts_form: {
        op_type: "",
        op_name: "",
        juristic_name: "",
        count: "",
        lab_detail: "",
        instrument: "",
        product_used: "",
        lab_id: "",
      },
      companyContactMainIndex: null,
      companyContactIndex: null,
      mockData: [
        {
          op_type: "นอกมหาวิทยาลัย",
          op_name: "มหาวิทยาลัยธรรมศาสตร์",
          juristic_name: "มหาวิทยาลัยธรรมศาสตร์",
          count: "1",
          lab_detail: "สำนักงานอธิการบดี",
          instrument: "เครื่องปรับอากาศ",
          product_used: "เครื่องปรับอากาศ",
          lab_id: "NSTIS-0001",
        },
        {
          op_type: "ในมหาวิทยาลัย",
          op_name: "มหาวิทยาลัยธรรมศาสตร์",
          juristic_name: "มหาวิทยาลัยธรรมศาสตร์",
          count: "1",
          lab_detail: "สำนักงานอธิการบดี",
          instrument: "เครื่องปรับอากาศ",
          product_used: "เครื่องปรับอากาศ",
          lab_id: "NSTIS-0001",
        },
        {
          op_type: "ในมหาวิทยาลัย",
          op_name: "มหาวิทยาลัยธรรมศาสตร์",
          juristic_name: "มหาวิทยาลัยธรรมศาสตร์",
          count: "1",
          lab_detail: "สำนักงานอธิการบดี",
          instrument: "เครื่องปรับอากาศ",
          product_used: "เครื่องปรับอากาศ",
          lab_id: "NSTIS-0001",
        },
        {
          op_type: "ในโครงการอุทยานวิทยาศาสตร์",
          op_name: "มหาวิทยาลัยธรรมศาสตร์",
          juristic_name: "มหาวิทยาลัยธรรมศาสตร์",
          count: "1",
          lab_detail: "สำนักงานอธิการบดี",
          instrument: "เครื่องปรับอากาศ",
          product_used: "เครื่องปรับอากาศ",
          lab_id: "NSTIS-0001",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      GeneralForm: state => state.CForm.GeneralForm,
      userInfo: (state) => state.Auth.User,
    }),
    isFinal() {
      return (
        this.$route.query.doc_type && this.$route.query.doc_type === "progress"
      );
    },
  },
  created () {
    
    if (this.isSameId && !this.masterData.form_c) this.form = this.GeneralForm
    if (this.masterData.form_c) {
      this.form = {
        activity: this.masterData.form_c.project_section_general_info?.activity,
        project_name_th:
          this.masterData.form_c.project_section_general_info?.project_name_th,
        project_name_en:
          this.masterData.form_c.project_section_general_info?.project_name_en,
        lab_name: this.masterData.form_c.project_section_general_info?.lab_name,
        requirement_form: this.masterData.form_c.project_section_general_info?.requirement_form,
        requirement_form_id: this.masterData.form_c.project_section_general_info?.requirement_form_id,
        operation_period : this.masterData.form_c.project_section_general_info?.operation_period,
      }
    }
    this.form.science_park = this.form.science_park || "อุทยานวิทยาศาสตร์ " + this.userInfo.region

    // set company_contacts กรณีแก้ไข
    if (this.masterData?.form_c?.company_contacts) {
      this.masterData?.form_c?.company_contacts.forEach((company_contact) => {
        if (company_contact.op_type == "นอกมหาวิทยาลัย") {
          this.company_contacts[1].items.push(company_contact);
        } else if (company_contact.op_type == "ในมหาวิทยาลัย") {
          this.company_contacts[0].items.push(company_contact);
        } else if (company_contact.op_type == "ในโครงการอุทยานวิทยาศาสตร์") {
          this.company_contacts[2].items.push(company_contact);
        }
      });
    }

    eventBus.$on("cFormGeneral", () => {
      eventBus.$emit("cFormGeneralSend", {
        ...this.form,
        company_contacts: this.setCompanyContacts(),
      });
    });
    console.log("after bus");
  },
  methods: {
    setFormField(field, val) {
      this.form[field] = val;
      this.$forceUpdate();
    },

    addCompanyContact(type) {
      console.log("addCompanyContact", type);
      this.is_company_contacts_form = true;
      this.company_contacts_form.op_type = type;
    },

    setCompanyContacts() {
      let company_contacts = [];
      this.company_contacts.forEach((company_contact) => {
        company_contacts = company_contacts.concat(company_contact.items);
      });
      return company_contacts;
    },

    handleSubmitCompanyContactForm() {
      if (this.$refs.company_contacts_form.validate()) {
        // ถ้ามี companyContactIndex, companyContactMainIndex แสดงว่าเป็นการแก้ไข
        if (
          this.companyContactMainIndex != null &&
          this.companyContactIndex != null
        ) {
          this.updateCompanyContact();
        } else {
          this.saveCompanyContact();
        }
      }
    },

    clearCompanyContactForm() {
      this.company_contacts_form = {
        op_type: "",
        op_name: "",
        juristic_name: "",
        count: "",
        lab_detail: "",
        instrument: "",
        product_used: "",
        lab_id: "",
      };

      this.companyContactMainIndex = null;
      this.companyContactIndex = null;
      this.is_company_contacts_form = false;
    },

    saveCompanyContact() {
      console.log("saveCompanyContact");
      switch (this.company_contacts_form.op_type) {
        case "ในมหาวิทยาลัย":
          this.company_contacts[0].items.push(this.company_contacts_form);
          break;
        case "นอกมหาวิทยาลัย":
          this.company_contacts[1].items.push(this.company_contacts_form);
          break;
        case "ในโครงการอุทยานวิทยาศาสตร์":
          this.company_contacts[2].items.push(this.company_contacts_form);
          break;
      }
      this.clearCompanyContactForm();
    },

    updateCompanyContact() {
      console.log(
        "updateCompanyContact",
        this.companyContactMainIndex,
        this.companyContactIndex
      );

      // update ข้อมูลใน object ของ company_contacts ตามปีที่เลือก
      this.company_contacts[this.companyContactMainIndex].items[
        this.companyContactIndex
      ] = this.company_contacts_form;

      this.clearCompanyContactForm();
    },

    editCompanyContact(mainIndex, subIndex) {
      console.log("editCompanyContact", mainIndex, subIndex);
      this.companyContactMainIndex = mainIndex;
      this.companyContactIndex = subIndex;
      this.is_company_contacts_form = true;
      this.company_contacts_form = {
        ...this.company_contacts[mainIndex].items[subIndex],
      };
    },

    deleteCompanyContact(mainIndex, subIndex) {
      console.log("deleteCompanyContact", mainIndex, subIndex);
      this.company_contacts[mainIndex].items.splice(subIndex, 1);
    },
  },
};
</script>
<style lang="scss">
.company_contacts_form {
  label {
    font-weight: 500;
    font-size: 14px;
    color: #000000;
  }
  .v-input__slot,
  .v-text-field.v-text-field--solo .v-input__control {
    min-height: 40px !important;
    border-radius: 30px;
  }

  .v-text-field--full-width .v-input__prepend-outer,
  .v-text-field--full-width .v-input__prepend-inner,
  .v-text-field--full-width .v-input__append-inner,
  .v-text-field--full-width .v-input__append-outer,
  .v-text-field--enclosed .v-input__prepend-outer,
  .v-text-field--enclosed .v-input__prepend-inner,
  .v-text-field--enclosed .v-input__append-inner,
  .v-text-field--enclosed .v-input__append-outer {
    margin-top: 8px !important;
  }
  .v-input--is-readonly:not(.picker-field) .v-input__slot {
    background-color: #ffffff !important;
  }
  i.v-icon.notranslate.mdi.mdi-calendar.theme--light {
    color: #f7941d !important;
  }
}

.custom_simple_table {
  tbody {
    tr {
      td {
        background-color: #f5f5f5;
      }
    }
  }
}
</style>
